/**
 * @param  {} uDatePickerId
 * @param  {} uOptions
 * @param  {} uOptions.initDate  By default new Date() -  Pass initial Date to start DatePicker
 * @param  {} uOptions.onDaySelectorChange  selector event triggered on select day
 * @param  {} uOptions.onChange  callback function triggered on datepicker selection
 */
function dateTimePickerSelector(uDatePickerId,uOptions){
    if(typeof uDatePickerId === "undefined" || uDatePickerId == null){
        uDatePickerId = "uAssociationDaysPickerId";
    }
    var uInitDate = new Date();
    if(uOptions.initDate){
        uInitDate = uOptions.initDate;
    }
    var renderHTMLObj = {
        "daysPickerElementId":"uAssociationDaysPickerId",
        "initDate":uInitDate,
        "days":30,
        "startDate":uInitDate,
        "stopDate":uInitDate,
        "calculateDateRage": function calculateDateRage(stopDate,lDays){
            var lCurrentDate = new Date(stopDate);
            this.stopDate = new Date(stopDate);
            this.days = lDays;
            this.startDate = new Date(lCurrentDate.setDate(lCurrentDate.getDate() - this.days));
        },
        "fillDays": function fillDays(){
                var lMaxDuration = [],lSelectFilter = $('#'+this.daysPickerElementId);
                lMaxDuration.push(
                    { "id": 1, "value": 1, "option": localizeText('c1day') },
                    { "id": 5, "value": 5, "option": localizeText('c5days') },
                    { "id": 30, "value": 30, "option": '30 days' });
                // checking hours
                for (lKey in lMaxDuration) {
                    if (lMaxDuration.hasOwnProperty(lKey)) {
                        lSelectFilter.append($("<option/>").attr("value", lMaxDuration[lKey].value).text(lMaxDuration[lKey].option));
                    }
                }
                $('#'+this.daysPickerElementId).val(this.days);
                this.dateRangeHtml();
                function onChangeDaysSelector(e){
                    this.calculateDateRage(this.stopDate,parseInt(e.srcElement.value));
                    if(uOptions.onDaySelectorChange){
                        uOptions.onDaySelectorChange(e);
                    }
                    this.dateRangeHtml();
                }
                document.getElementById(this.daysPickerElementId).addEventListener('change',onChangeDaysSelector.bind(this));
        },
        "dateRangeHtml": function dateRangeHTML(){
            var textHtml =  ' to '+ flatpickr.formatDate(this.startDate, "F j, Y h:i:s K") ;
            document.getElementById('uDatesId').innerHTML = textHtml;
        },
        "htmlTemplate":[
               
                '<div class="form__group">',
                    '<label class="form__group--label__block">From:</label>',
                    '<input type="text" id="uAssociationDateTimePickerId" value="" style="float:left;" class="DateTimeItem date__input MapStartDateFilter" />',
                '</div>',
                '<div class="form__group"><div id="uDatesId"></div></div>',
                '<div  class="form__group">',
                    // '<label class="form__group--label__block">Show last :</label>',
                    '<select id="uAssociationDaysPickerId"  style="margin-left: 0;height:20px;line-height:20px;"></select>',
                '</div>',
        ].join(''),
        "init": function(){
            this.calculateDateRage(uInitDate,this.days);
            var currentDate = flatpickr.formatDate(uInitDate, "m-d-Y h:i K");
            var _this = this;
            flatpickr(".DateTimeItem",{
                enableTime:true,
                altInput: true,
                altFormat: "F j, Y h:i:s K",
                dateFormat:'m-d-Y h:i:s K',
                defaultDate: currentDate,
                defaultHour:this.stopDate.getHours(),
                defaultMinute:this.stopDate.getMinutes(),
                maxDate:new Date(),
                onChange: onChangeFn.bind(this),
            });
            function onChangeFn(selectedDates, dateStr, instance) {
                var uStopDate = new Date(selectedDates[0]);
                var uDays = document.getElementById(_this.daysPickerElementId).value;
                _this.calculateDateRage(uStopDate,parseInt(uDays));
                if(uOptions.onChange){
                    uOptions.onChange(selectedDates, dateStr, instance);
                }
                this.dateRangeHtml();
            }
            this.fillDays();

        }
    };
    
    
    return renderHTMLObj;
}

function VisitAssociationsModal(type,e,gMap){
    var lButtonBar = GenerateButtonCommandBar(),VisitAssociationListView = null,
        offender = getDataItem(mEnrolleesData.OffenderCurrentId,'Enrollees'),
        lAddressId = e.sumoData.AddressId,
        lDays = 30,
        lDatePicker = dateTimePickerSelector("uAssociationDaysPickerId",{
            "days":30,
            "initDate":new Date($('#uMapStartDatePicker').val() + ' ' + $('#uMapStartTimePicker').val()),
            "onDaySelectorChange":function(){
                getAssociations();
            },
            "onChange":function(selectedDates, dateStr, instance){
                getAssociations();
            }
        });
    var aTypeTitle =  {
        'this': offender.FullName  +' Associations ', 
        'all':'All Associations  '
    };
    gMap.reverseGeocode(e.position.lat(),e.position.lng(),function(address){
        document.getElementById('uVisitAssociationTitleId').innerText = AddressHelper.getFullFromObject(address);
    });
    
    var loadingBar = {
        "loadingBarElm":function(){
            return document.getElementById('uVisitAssociationLoadingBar');
        },
        "listViewElm":function(){
            return document.getElementById('uVisitAssociationListViewHolder');
        },
        "show":function(){
            this.loadingBarElm().style.display = 'block';
            this.listViewElm().style.display = 'none';
        },
        "hide":function(){
            this.listViewElm().style.display = 'block';
            this.loadingBarElm().style.display = 'none';
        }
    }
    GenerateButton('Cancel', 'Cancel', ClosePopup).appendTo(lButtonBar);
    GenerateButton('Print', 'Print', function(){
        var uPrint = window.open('Enrollees.Offenders.Map.Associations.Print.htm');
        uPrint.opener.VisitAssociationListView = document.querySelector('thead').outerHTML;
        uPrint.opener.VisitAssociationTableContent = document.getElementById('uVisitAssociationListViewBody').outerHTML;
        uPrint.opener.VisitAssociationTitle = document.getElementsByClassName('wrapper')[0].innerHTML;
        uPrint.opener.VisitAssociationTab = document.getElementsByClassName('cEnrolleeProfile')[0].innerHTML;
        uPrint.opener.VisitAssociationStartDate = document.getElementsByClassName('DateTimeItem date__input')[1].value;
        uPrint.opener.VisitAssociationEndDate = document.getElementById('uDatesId').innerHTML;
        uPrint.opener.VisitAssociationDays = document.getElementById('uAssociationDaysPickerId').value;
        
    }).appendTo(lButtonBar);
    DisplayPopup('<div class="wrapper">'+aTypeTitle[type]+' <div id="uVisitAssociationTitleId" style="font-size:10px; font-weight:100;" class="item noOverflowEllipsis"></div></div>', htmlTemplate(), lButtonBar, false);
    loadingBar.show();
    lDatePicker.init();
    if (isNullOrUndefined(VisitAssociationListView)) {
        var lColumns = [
            { 'id': 'PointGroupingId','dataField': 'PointGroupingId', 'width': 0, 'minWidth': 0, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'PrimaryId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Name', 'title': localizeWrapper('cEnrolleeFullName'), 'dataField': 'EnrolleeName', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Organization', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationName', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Start', 'title': localizeWrapper('cEventStartDate'), 'dataField': 'StartDate', 'width': 'autoData', 'minWidth': 135, 'sortable': false, 'cssClass': null, 'dataType': 'date',formatMethod:formatStartEndDateTimeToEnrollee},
            { 'id': 'Stop', 'title': localizeWrapper('cEventStopDate'), 'dataField': 'StopDate', 'width': 'autoData', 'minWidth': 135, 'sortable': false, 'cssClass': null, 'dataType': 'date',formatMethod:formatStartEndDateTimeToEnrollee },
            { 'id': 'Duration', 'title': 'Duration (min)', 'dataField': 'Duration', 'width': 'autoHeader', 'minWidth': 85, 'sortable': false, 'cssClass': null, 'dataType': 'number' }
        ];

        VisitAssociationListView = new sumo.controls.ListView('uVisitAssociationListView', 'uVisitAssociationListViewHolder', { 'keyField': 'PointGroupingId', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
    }
    var lShowAll  = type === 'this' ? 0 : 1;
    getAssociations();
    function getAssociations(){
        loadingBar.show();
        var lEnrolleeId  = type === 'this' ? mEnrolleesData.OffenderCurrentId : -1;
        veritracks.mapping.getEnrolleeAssociationsVisit(lEnrolleeId,lAddressId,lDatePicker.startDate,lDatePicker.stopDate,lShowAll, function(aParams, aAssociationsData){
            VisitAssociationListView.setDataSource(aAssociationsData);
            loadingBar.hide();
    }, Sad, {});
    }
    

    function htmlTemplate(){
        return [
            '<div class="" style="width:585px;" >',
                    '<div id="uVisitAssociationListView" class="ContentSecondaryOverhead ContentSecondaryMenu">',
                        '<ul class="MenuList">',
                            '<li class="Clickable ContentPrimaryTab ProfileTab pEnrolleesOffenderProfile Selected"><span class="cLocalize cEnrolleeProfile">Visits</span></li>',
                        '</ul>',
                    '</div>',
                    '<div id="uEnrolleesTime" class="tab__buttons__panel">',
                        lDatePicker.htmlTemplate,
                    '</div>',
                    '<div id="uVisitAssociationContentPanel"  class="NotScrollable ContentSecondaryHolder" style="width: 100%; height: 267px; max-height: 267px; min-height: 267px;" >',
                        '<div class="" style="width: 100%;height: 100%; float: right;">',
                            '<div id="uVisitAssociationLoadingBar" style="display: none; width: 100%; height: 100%; background: white; z-index: 1000;"><img id="uLoadingBarAssociationsImg" style="display: inline-block;position:absolute;left:50%;top:50%;margin-left: -80px;margin-top: -80px;" src="Images/CircleLoader.gif" alt="Loading..."></div>',
                            '<div id="uVisitAssociationListViewHolder" class="" style="height: 100%; width: 100%;" >',
                            '</div>',
                        '</div>',
                    '</div>',
                '</div>',
        ].join(" ");
    }
}

function PriorVisitEnrolleesModal(type,e,gMap){
    var lButtonBar = GenerateButtonCommandBar(),VisitAssociationListView = null,
        offender = getDataItem(mEnrolleesData.OffenderCurrentId,'Enrollees'),
        lAddressId = e.sumoData.AddressId;
        var lDatePicker = dateTimePickerSelector("uAssociationDaysPickerId",{
            "days":30,
            "initDate":new Date($('#uMapStartDatePicker').val() + ' ' + $('#uMapStartTimePicker').val()),
            "onDaySelectorChange":function(){
                getPriorVisits();
            },
            "onChange":function(selectedDates, dateStr, instance){
                getPriorVisits();
            }
        });
    var aTypeTitle =  {
        'this': offender.FullName  +' Prior Visits  ', 
        'all':'All Prior Visits  '
    };
    gMap.reverseGeocode(e.position.lat(),e.position.lng(),function(address){
        document.getElementById('uVisitAssociationTitleId').innerText = AddressHelper.getFullFromObject(address);
    });
    var loadingBar = {
        "loadingBarElm": function(){
            return document.getElementById('uVisitAssociationLoadingBar');
        },
        "listViewElm": function(){
            return document.getElementById('uVisitAssociationListViewHolder')
        },
        "show": function(){
            this.loadingBarElm().style.display = 'block';
            this.listViewElm().style.display = 'none';
        },
        "hide": function(){
            this.listViewElm().style.display = 'block';
            this.loadingBarElm().style.display = 'none';
        }
    }
    GenerateButton('Cancel', 'Cancel', ClosePopup).appendTo(lButtonBar);
    GenerateButton('Print', 'Print', function(){
        var uPrint = window.open('Enrollees.Offenders.Map.Associations.Print.htm');
        uPrint.opener.VisitAssociationListView = document.querySelector('thead').outerHTML;
        uPrint.opener.VisitAssociationTableContent = document.getElementById('uVisitAssociationListViewBody').outerHTML;
        uPrint.opener.VisitAssociationTitle = document.getElementsByClassName('wrapper')[0].innerHTML;
        uPrint.opener.VisitAssociationTab = document.getElementsByClassName('cEnrolleeProfile')[0].innerHTML;
        uPrint.opener.VisitAssociationStartDate = document.getElementsByClassName('DateTimeItem date__input')[1].value;
        uPrint.opener.VisitAssociationEndDate = document.getElementById('uDatesId').innerHTML;
        uPrint.opener.VisitAssociationDays = document.getElementById('uAssociationDaysPickerId').value;
        
    }).appendTo(lButtonBar);
    DisplayPopup('<div class="wrapper">'+aTypeTitle[type]+' at <div id="uVisitAssociationTitleId" style="font-size:10px; font-weight:100;" class="item noOverflowEllipsis"></div> </div>', htmlTemplate(), lButtonBar, false);
    
    if (isNullOrUndefined(VisitAssociationListView)) {
        var lColumns = [
            { 'id': 'PointGroupingId','dataField': 'PointGroupingId', 'width': 0, 'minWidth': 0, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId'), 'dataField': 'PrimaryId', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Name', 'title': localizeWrapper('cEnrolleeFullName'), 'dataField': 'EnrolleeName', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Organization', 'title': localizeWrapper('cEnrolleeOrganization'), 'dataField': 'OrganizationName', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'Start', 'title': localizeWrapper('cEventStartDate'), 'dataField': 'StartDate', 'width': 'autoData', 'minWidth': 135, 'sortable': false, 'cssClass': null, 'dataType': 'date','formatMethod':formatStartEndDateTimeToEnrollee},
            { 'id': 'Stop', 'title': localizeWrapper('cEventStopDate'), 'dataField': 'StopDate', 'width': 'autoData', 'minWidth': 135, 'sortable': false, 'cssClass': null, 'dataType': 'date','formatMethod':formatStartEndDateTimeToEnrollee },
            { 'id': 'Duration', 'title': 'Duration (min)', 'dataField': 'Duration', 'width': 'autoHeader', 'minWidth': 70, 'sortable': false, 'cssClass': null, 'dataType': 'number' },
            { 'id': 'Frequency', 'title': 'Frequency (min)', 'dataField': 'Frequency', 'width': 'autoHeader', 'minWidth': 70, 'sortable': false, 'cssClass': null, 'dataType': 'number' }
        ];

        VisitAssociationListView = new sumo.controls.ListView('uVisitAssociationListView', 'uVisitAssociationListViewHolder', { 'keyField': 'PointGroupingId', 'selectMethod': 'auto', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
    }
    lDatePicker.init();

    getPriorVisits();

    function getPriorVisits(){
        loadingBar.show();
        var lEnrolleeId  = type === 'this' ? mEnrolleesData.OffenderCurrentId : -1,
        lDataFlag = CheckUserHasPermission(45) ? 1 : 0;
        veritracks.mapping.getEnrolleePriorVisit(lEnrolleeId,lAddressId,lDatePicker.startDate,lDatePicker.stopDate,lDataFlag, function(aParams, aAssociationsData){
            
             VisitAssociationListView.setDataSource(aAssociationsData);
             loadingBar.hide();
     }, Sad, {});
    }
    function htmlTemplate(){
        return [
            '<div class="" style="width:655px;" >',
                    '<div id="uVisitAssociationListView" class="ContentSecondaryOverhead ContentSecondaryMenu">',
                        '<ul class="MenuList">',
                            '<li class="Clickable ContentPrimaryTab ProfileTab pEnrolleesOffenderProfile Selected"><span class="cLocalize cEnrolleeProfile">Prior Visits</span></li>',
                        '</ul>',
                    '</div>',
                    '<div id="uEnrolleesTime" class="tab__buttons__panel">',
                        lDatePicker.htmlTemplate,
                    '</div>',
                    '<div id="uVisitAssociationContentPanel"  class="NotScrollable ContentSecondaryHolder" style="width: 100%; height: 267px; max-height: 267px; min-height: 267px;" >',
                        '<div class="" style="width: 100%;height: 100%; float: right;">',
                            '<div id="uVisitAssociationLoadingBar" style="display: none; width: 100%; height: 100%; background: white; z-index: 1000;"><img id="uLoadingBarAssociationsImg" style="display: inline-block;position:absolute;left:50%;top:50%;margin-left: -80px;margin-top: -80px;" src="Images/CircleLoader.gif" alt="Loading..."></div>',
                            '<div id="uVisitAssociationListViewHolder" class="" style="height: 100%; width: 100%;" >',
                            '</div>',
                        '</div>',
                    '</div>',
                '</div>',
        ].join(" ");
    }
}

function MarkVisitAsKnownModal(e){
    var lButtonBar = GenerateButtonCommandBar(),
        offenderId = mEnrolleesData.OffenderCurrentId,
        lVisit = e.sumoData;
        var currentPopContainerClass = document.getElementById('uPopupContainer').className;
        GenerateButton('Yes, Mark as Known', 'Save', function () {
        veritracks.mapping.setVisitUpdateType(lVisit.Id,offenderId,lVisit.AddressId,lVisit.DeviceId,lVisit.ZoneId, function(aParams, aAssociationsData){
                ClosePopup();
                document.getElementById('uPopupContainer').className = currentPopContainerClass;
                offenderMapPopulate();
                mActivityNotification.addNotification('The visit has been successfully saved');
        }, Sad, {});
    }).appendTo(lButtonBar);
    GenerateButton('Cancel', 'Cancel', ClosePopup).appendTo(lButtonBar);
    DisplayPopup('<div class="wrapper">Alert</div>', htmlTemplate(), lButtonBar, true);
    document.getElementById('uPopupContainer').className = 'WarningModal';
    function htmlTemplate(){
        return [
            '<div class="ContentSecondaryPanel"  style="padding: 15px; text-align: center;">',
                '<p>Are you sure you would like to mark this Visit as Known?<br> </p>',
            '</div>',
        ].join(" ");
    }
}